import { render, staticRenderFns } from "./ContentDisplay.vue?vue&type=template&id=3666993c"
import script from "./ContentDisplay.vue?vue&type=script&lang=js"
export * from "./ContentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports